<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="Form"
          :model="planData"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="播放日期" prop="FileName">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  placeholder="开始日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 56rem"
                  unlink-panels
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="每日循环" prop="RepeatEveryDay">
                <el-switch v-model="planData.RepeatEveryDay"></el-switch>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="播放时间" prop="time">
                <!-- <el-time-picker
                  v-model="time"
                  is-range
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 56rem"
                ></el-time-picker> -->
                <el-time-picker
                  is-range
                  v-model="time"
                  style="width: 56rem"
                  value-format="HH:mm:ss"
                  :clearable="false"
                ></el-time-picker>
              </el-form-item>
            </el-col>
           </el-row>
            <el-row>
            <el-col :span="12">
              <el-form-item label="是否循环" prop="loopStatus">
                <el-switch v-model="planData.loopStatus"  
                  active-text="是"
                  inactive-text="否"
                  active-value="1"
                  inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="播放音量" prop="volume">
                <el-slider v-model="planData.volume"></el-slider>
              </el-form-item>
            </el-col>
            <div style="padding-top: 1rem">
              <span>{{ planData.volume }}%</span>
            </div>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button @click="preStep">上一步</el-button>
        <el-button type="primary" @click="OnConfirm('Form')"
          >保存,下一步</el-button
        >
        <el-button @click="onBack">返回</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import { BroadcastInfo, editBroadcast} from "@/api/src/broadcast";
export default {
  name: "PlanInfo",
  props: {
    // data: {
    //   type: Object,
    // },
    taskId: {
      type: String,
    },
    PlanList: {
      type: Array,
    },
  },
  data() {
    return {
      planData: {
        loopStatus:0,
        volume:0
      },
      loading: false,
      loadingText: "加载中...",
      rules: {},
      date: [new Date().format("yyyy-MM-dd"), new Date().format("yyyy-MM-dd")],
      // time: [new Date(2020, 1, 1, 9, 0), new Date(2020, 12, 31, 18, 0)],
      time: [],
      notChoiceDataList: [], //备选节目
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
    };
  },
  created() {
    this.initTime();
    this.getPlan();
  },
  methods: {
    initTime(){
       let time1 = new Date(2020, 1, 1, 9, 0);
       let hour1 = time1.getHours();
       hour1 = hour1<10?"0"+hour1:hour1;
       let minte1 = time1.getMinutes();
       minte1 = minte1<10?"0"+minte1:minte1;
       let seconds1 = time1.getSeconds();
       seconds1 = seconds1<10?"0"+seconds1:seconds1;
       let timearr0 = hour1+":"+minte1+":"+seconds1;
       this.time.push(timearr0)
       let time2 = new Date(2020, 12, 31, 18, 0);
       let hour2 = time2.getHours();
       hour2 = hour2<10?"0"+hour2:hour2;
       let minte2 = time2.getMinutes();
       minte2 = minte2<10?"0"+minte2:minte2;
       let seconds2 = time2.getSeconds();
       seconds2 = seconds2<10?"0"+seconds2:seconds2;
       let timearr1 = hour2+":"+minte2+":"+seconds2;
       this.time.push(timearr1)
    },
    getPlan() {
      let InfoId = this.taskId;
      const that = this;
      if (this.PlanList.length > 0 || this.taskId) {
        BroadcastInfo({id:InfoId}).then(res=>{
          console.log("单个信息")
          console.log(res)
          if(res.code==200){
            this.planData = res.data;
            if(this.planData.loopStatus=="null"){
              this.planData.loopStatus = 0;
            }
            // console.log(this.planData.beginDate)
            if(this.planData.beginDate!=null){
              this.date=[];
              this.date.push(this.planData.beginDate);
              this.date.push(this.planData.endDate);
            }
            if(this.planData.beginTime!=null){
              this.time=[];
              this.time.push(this.planData.beginTime);
              this.time.push(this.planData.endTime);
            }
            // console.log("this.date")
            // console.log(this.date)
            // console.log(this.time)
          }
        })
      }
    },

    OnConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveFormData();
        } else {
          return false;
        }
      });
    },
    onBack() {
      this.$emit("onBack", {});
    },
    nextStep() {
      this.$emit("nextStep", {});
    },
    preStep() {
      this.$emit("preStep", {});
    },
    search() {
      this.$emit("search", {});
    },
    saveFormData(){
      this.planData.beginDate = this.date[0];
      this.planData.endDate = this.date[1];
      this.planData.beginTime = this.time[0];
      this.planData.endTime = this.time[1];
      console.log("this.planData")
      console.log(this.planData)
       //编辑
       editBroadcast(this.planData).then(res=>{
          console.log("更新播单结果")
          console.log(res)
          if(res.code==200){
            this.$message({
              type: "success",
              message: "保存成功！!",
            });
            this.nextStep();
          }else{
            this.errmsg("保存失败！");
          }
        })
    },
    saveData() {
      let uuid = "";

      uuid = ZJApp.ZJUtils.uuid();
      if (this.taskId == "") {
        return;
      }
      this.planData.TaskId = this.taskId;
      this.planData.RepeatEveryDay = this.planData.RepeatEveryDay ? 1 : 0;
      this.planData.RepeatAfterFinished = this.planData.RepeatAfterFinished
        ? 1
        : 0;
      this.planData.PlanStartDate = this.date[0];
      this.planData.PlanEndDate = this.date[1];
      this.planData.PlanStarTime = this.time[0];
      this.planData.PlanEndTime = this.time[1];
      if (this.PlanList.length > 0) {
        //编辑
        this.planData.ModifyTime = new Date();
        this.planData.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.planData);
        formAll = JSON.parse(formAll);
        new MyApis.TaskPlanApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "播放计划修改";
            this.logInfo.LogMessage = r
              ? "播放计划修改成功"
              : "播放计划修改失败";
            this.logInfo.ModuleName = "广播系统";
            this.logInfo.PageName = "播单管理详情";
            this.addOperationLog();
            // this.search();
            this.getPlan();
            this.nextStep();
            //this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          TaskPlanId: uuid,
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.planData);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TaskPlanApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.TaskId = uuid;
            this.logInfo.ActionName = "播单信息添加";
            this.logInfo.LogMessage = r
              ? "播单信息添加成功"
              : "播单信息添加失败";
            this.logInfo.ModuleName = "广播系统";
            this.logInfo.PageName = "播单管理详情";
            this.addOperationLog();
            //  this.search();
            this.getPlan();
            this.nextStep();
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
